import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './licitaciones.css';
import { licitaciones_item } from '../../json/licitacionesItem';

const Licitaciones = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container licitaciones-container container-mh'>
            <div className='row'>
                <h3 className='title'>Licitaciones Públicas</h3>
                <hr className='hr-gob' />
            </div>
            <div className='row'>
                {
                    licitaciones_item.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12 licitaciones_item'>
                            <Link to={item.licitaciones_item_url}>{item.licitaciones_item_nombre}</Link>
                            <div className='licitaciones_descripcion'>
                                <h6>{item.licitaciones_item_descripcion}</h6>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Licitaciones